module.exports = __webpack_public_path__ + "static/media/Preview_blue.74c93276.png";